export enum FrameworkStateType {
    XR_ENGINE_CONTEXT = 'xr-engine-context',
    SPACE_STATE = 'space-state',
    COMMUNICATION_STATE = 'communication-state',
}
